import { FetchResult } from 'apollo-link';

import { offlineReportCreateQuery, offlineReportListQuery } from '../../graphql/queries/grid/reportsDomain';
import { GdOfflineReportResultRequestInput, offlineReportCreate, offlineReportList } from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export class ReportsDomainDataProvider extends BaseDataProvider {
    public fetchReportsDomainData(): Promise<offlineReportList> {
        return this.createQuery<offlineReportList>(offlineReportListQuery).then(result => {
            return result.data;
        });
    }

    public async addReportsDomain(data: GdOfflineReportResultRequestInput): Promise<FetchResult<offlineReportCreate>> {
        return this.createQuery<offlineReportCreate>(offlineReportCreateQuery, {
            variables: {
                input: data
            }
        });
    }
}
